"use client";

import { WindowSize } from "@/global";
import { ClassValue, clsx } from "clsx";
import { useEffect, useState } from "react";
import { twMerge } from "tailwind-merge";

export const cn = (...inputs: ClassValue[]) => twMerge(clsx(inputs));

export const useScroll = (): number => {
  const [scrollPos, setScrollPos] = useState<number>(0);

  useEffect(() => {
    const handleScroll = () => setScrollPos(window.scrollY);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return scrollPos;
};

export const useWindowSize = (): WindowSize => {
  const getSize = (): WindowSize => {
    return {
      width: window.innerWidth,
      height: window.innerHeight,
    };
  };

  const [windowSize, setWindowSize] = useState<WindowSize>(getSize);

  useEffect(() => {
    const handleResize = () => {
      setWindowSize(getSize());
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return windowSize;
};

export const scrollToTop = () =>
  typeof window !== "undefined" ? window.scrollTo({ top: 0 }) : undefined;

export const randomGradientColors = () => {
  const colors = [
    ["#693300", "#801E00", "#000", "#0069A6"],
    ["#FF4D6D", "#FF6F91", "#845EC2", "#6A0DAD"],
    ["#00FFAB", "#00B3FF", "#0026FF", "#8A00FF"],
    ["#FF9F1C", "#FF4040", "#8338EC", "#3A86FF"],
  ];

  const gradient = colors[Math.floor(Math.random() * colors.length)];
  return `linear-gradient(90deg, ${gradient.join(", ")})`;
};
